module.exports = __webpack_public_path__ + "static/media/8.f3bffbb0.JPG";